<template lang="pug">
div
    div.box(v-for="settings in sortGroupedSettings(groupedSettings)")
        div.box-header.b-b
            h3 {{ settings[0].group.name }}
            small(v-if="settings[0].group.description != null") {{ settings[0].group.description }}

        div.box-body
            form-input(
                v-for="setting in sortSettings(settings)"
                :validator="validator",
                :setting="setting",
                :key="setting.id"
            )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import formInput from './central-setting-form-input.vue';

export default {
    components: { formInput },

    props: {
        validator: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters('centralSettings', ['groupedSettings']),

        sortGroupedSettings: () => settings => {
            return _.orderBy(settings, e => e[0].group.sequence);
        },

        sortSettings: () => settings => {
            return _.sortBy(settings, ['sequence']);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/central-settings/central-setting-form-container.vue